import { lazy } from 'react';

const UniversityAccountsPage = lazy(() =>
  import('./page.js').then((module) => ({ default: module.UniversityAccountsPage })),
);
const UniversityAccountDetailPage = lazy(() =>
  import('./[id]/page.js').then((module) => ({ default: module.UniversityAccountDetailPage })),
);

export { UniversityAccountDetailPage, UniversityAccountsPage };
